import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Input';
import { Button } from '../Button';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import { getBookCover } from '../../shared/book-covers';
import styles from './NameSlide.css';

function NameSlide({ id, submitAnswer, results, userResponse = {} }) {
    const [name, setName] = useState(userResponse.text || '');
    const trimmedName = name.trim();

    const handleSubmit = event => {
        event.preventDefault();

        if (!trimmedName) return;

        logEvent(EVENT_TYPES.NAME_SUBMITTED);
        submitAnswer({ questionId: id, question: 'What’s your name?', text: trimmedName })();
    };

    return (
        <form className={styles.root} onSubmit={handleSubmit}>
            <h1 className={styles.title}>What’s your name?</h1>
            <p className={styles.description}>Every author needs a name. Enter your name to see your cover</p>
            <Input
                value={name}
                name='name'
                onChange={(_, value) => setName(value)}
                className={styles.input}
                placeholder='Your name'
                inputProps={{ autoComplete: 'given-name', maxLength: 40 }}
            />
            <div className={styles.preview} aria-hidden='true'>
                <img src={getBookCover(results.userResponses)} alt='' className={styles.cover} />
            </div>
            <div className={styles.footer}>
                <Button
                    type='berry'
                    label='Continue'
                    disabled={!trimmedName}
                    inSlide
                    buttonProps={{ type: 'submit' }}
                />
            </div>
        </form>
    );
}

NameSlide.propTypes = {
    id: PropTypes.number.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired,
    userResponse: PropTypes.object
};

export {
    NameSlide
};
